import React from 'react';
import { FormattedMessage } from 'react-intl';

const Organization = () => {
  return (
    <div>
      <h2 className="ui header">
        <FormattedMessage
          id="organization"
          description="Organization menu item"
        />
      </h2>
      <div className="ui text container">
        <p>
          <FormattedMessage
            id="organizationText"
            description="Organization text"
          />
        </p>
        <a
          className="ui big blue button"
          href="http://informa.com" target="_blank"
          rel="noopener noreferrer"
        >
          informa.com
        </a>
      </div>
    </div>
  );
};

export default Organization;



/** WEBPACK FOOTER **
 ** ./src/components/screens/organization/Organization.js
 **/